export default function HeroImagePanel({ className, imageUrl }) {
  return <div className={className} style={{ backgroundImage: `url(${imageUrl})` }} />;
}
